import fetch from 'isomorphic-fetch';

const wait = ms => new Promise(r => setTimeout(r, ms));

const fetchRetry = (
	url,
	options = {},
	times = 3,
	delay = 1500
) => new Promise(async (resolve, reject) => { //eslint-disable-line
	try {
		const resp = await fetch(url, options);

		if (resp.status === 200) {
			return resolve(resp);
		}

		throw new Error(resp);
	} catch (e) {
		if (times - 1 > 0) {
			await wait(delay);

			try {
				const resp = await fetchRetry(url, options, times - 1, delay);
				return resolve(resp);
			} catch (err) {
				return reject(err);
			}
		}

		reject(e);
	}
});

export default fetchRetry;



// WEBPACK FOOTER //
// ./src/main/webapp/media/scripts/webpack/funcs/fetchRetry.js